<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <br />
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" stripe>
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" align="center" width="90"> </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="150">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"> </el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"> </el-table-column>

            <el-table-column prop="createTime" align="center" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="rejectTime" align="center" label="被退稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.rejectTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="rejectRemark" label="退稿原由">
              <template slot-scope="scope">
                <el-tag type="danger">{{ scope.row.rejectRemark }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="statusRefund" label="退款状态" v-if="$config.isCharge">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.statusRefund == 0">
                  <template v-if="scope.row.costed2 == -1">无需退款</template>
                  <template v-else>尚未申请</template>
                </el-tag>
                <el-tag type="warning" v-else-if="scope.row.statusRefund == 1">已申请</el-tag>
                <el-tag type="danger" v-else-if="scope.row.statusRefund == 2">已退款</el-tag>
                <el-tag type="danger" v-else-if="scope.row.statusRefund == 3">拒绝退款</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="流程查看" align="center" width="90">
              <template slot-scope="scope">
                <el-button size="mini" @click="showProcess(scope.row.id)">查看流程</el-button>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" align="center" width="90">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" v-if="scope.row.costed2 != -1 && scope.row.statusRefund == 0" @click="redfundAddPrev(scope.row.id)">申请退款</el-button>
                <el-button size="mini" type="default" v-if="scope.row.costed2 != -1 && scope.row.statusRefund >= 1" @click="refundPage">退款记录</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-pagination background layout="prev, pager, next" :page-size="10" :total="total" @current-change="pageChange" @prev-click="pagePrev" @next-click="pageNext" style="float: right"> </el-pagination>
      </el-row>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div style="padding: 0 20px 20px 20px">
        <ArticleProcess ref="ArticleProcess" :articleId="articleId" role="USER"></ArticleProcess>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import authorApi from "@/api/author"
import refundApi from "@/api/refund"

export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "被退稿稿件" }],
      curPage: 1,
      tableData: [],
      total: 0,
      pageSize: 10,

      drawer: false,
      drawerTitle: "",
      drawerAction: "",
      articleId: null,
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    //加载数据
    loadData() {
      authorApi.myArticleRejectedList(this.curPage, this.pageSize).then((res) => {
        this.total = res.total
        this.tableData = res.rows
      })
    },

    openDraw(title, action) {
      this.drawerAction = action
      this.drawer = true
      this.drawerTitle = title
    },
    closeDrawer() {
      this.drawer = false
    },

    showProcess(articleId) {
      this.openDraw("查看流程", "process")
      this.articleId = articleId
    },

    refundPage() {
      this.$router.push("/article/myRefundList")
    },

    redfundAddPrev(articleId) {
      this.articleId = articleId
      refundApi.getInfo(articleId).then((res) => {
        if (res.code == 0) {
          this.refundAdd(articleId, res.data)
        } else {
          this.$notify.error({
            title: "错误",
            message: res.msg,
          })
        }
        console.log(res)
      })
    },

    refundAdd(articleId, data) {
      this.articleId = articleId
      this.$confirm("原支付费用" + data.payAmount + "元，扣款" + data.deductAmount + "元（查重检测费），退款金额<span class='money'>" + data.refundableAmount + "</span>元，退款将从原路返回, 是否继续?", "申请退款提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        refundApi.add(this.articleId).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: res.msg,
              type: "success",
            })
            this.loadData()
            this.getStat()
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },

    pageChange(current) {
      this.curPage = current
      this.loadData()
    },
    pagePrev(current) {
      this.curPage = current
    },
    pageNext(current) {
      this.curPage = current
    },
  },
}
</script>
